import { render } from "./Outline.vue?vue&type=template&id=0ff8c131&scoped=true"
import script from "./Outline.vue?vue&type=script&lang=js"
export * from "./Outline.vue?vue&type=script&lang=js"

import "./Outline.vue?vue&type=style&index=0&id=0ff8c131&scoped=true&lang=css"
import "@/assets/css/essayWriting.sass?vue&type=style&index=1&id=0ff8c131&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff8c131"]])

export default __exports__